module.exports = __webpack_public_path__ + "img/2014-1.38a4b8e5.jpg";